import DashboardSubscribersChart from './DashboardSubscribersChart';

export default DashboardSubscribersChart;
